import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
} from '@angular/core';

@Component({
  selector: 'ps-ui-select-dropdown-item',
  templateUrl: './select-dropdown-item.component.html',
  styleUrls: ['./select-dropdown-item.component.css'],
})
export class SelectDropdownItemComponent {
  @Input() clickedItem: any;

  @Output() clicked = new EventEmitter();
  @Output() readonly selectNextItem = new EventEmitter();
  @Output() readonly selectPreviousItem = new EventEmitter();
  @Output() readonly exitItems = new EventEmitter();

  @ViewChild('item')
  item!: ElementRef;

  click() {
    if (this.clickedItem.isNotSelectable) {
      return;
    }
    this.clicked.emit(this.clickedItem);
  }

  keydown(e: KeyboardEvent, _: any) {
    switch (e.key) {
      case 'Enter':
        this.click();
        break;
      case ' ':
        this.click();
        break;
      case 'ArrowDown':
        e.preventDefault();
        this.selectNextItem.emit();
        break;
      case 'ArrowUp':
        e.preventDefault();
        this.selectPreviousItem.emit();
        break;
      case 'Escape':
        this.exitItems.emit();
        break;
    }
  }

  focus() {
    this.item.nativeElement.focus();
  }
}
